import { AxiosResponse } from 'axios';
import {
  ICurriculumPayload,
  ICreateCurriculumResponse,
  ICurriculumResponse,
  ICurriculumResponseById,
  ICurriculumQueryParams,
  ICurriculumStatusResponse,
  ICurriculumDeleteSuccessResponse,
} from '../../interface';
import api from '../api';
import {
  IUpdateOperationalTimePreferencePayload,
  IUpdateOperationalTimePreferenceResponse,
} from '../../interface/operationalTime.interface';

const fetchCurriculums = async (
  params?: ICurriculumQueryParams,
): Promise<AxiosResponse<ICurriculumResponse>> => {
  const res: AxiosResponse<ICurriculumResponse> = await api.get('/curriculum', {
    params,
  });
  return res;
};

const fetchCurriculum = async (
  curriculumId: string,
): Promise<AxiosResponse<ICurriculumResponseById>> => {
  const res: AxiosResponse<ICurriculumResponseById> = await api.get(`/curriculum/${curriculumId}`);
  return res;
};

const createCurriculum = async (
  payload: ICurriculumPayload,
): Promise<AxiosResponse<ICreateCurriculumResponse>> => {
  const res: AxiosResponse<ICreateCurriculumResponse> = await api.post('/curriculum', payload);
  return res;
};

const updateCurriculum = async (
  curriculumId: string,
  payload: ICurriculumPayload,
): Promise<AxiosResponse<ICreateCurriculumResponse>> => {
  const res: AxiosResponse<ICreateCurriculumResponse> = await api.put(
    `/curriculum/${curriculumId}`,
    payload,
  );
  return res;
};

const updateOperationalTime = async (
  curriculumId: string,
  payload: IUpdateOperationalTimePreferencePayload,
): Promise<AxiosResponse<IUpdateOperationalTimePreferenceResponse>> => {
  const res: AxiosResponse<IUpdateOperationalTimePreferenceResponse> = await api.put(
    `/curriculum/${curriculumId}/preferences`,
    payload,
  );
  return res;
};

const setCurriculumStatus = async (
  curriculumId: string,
  status: boolean,
  confirmed?: boolean,
): Promise<AxiosResponse<ICurriculumStatusResponse>> => {
  const res: AxiosResponse<ICurriculumStatusResponse> = await api.patch(
    `/curriculum/${curriculumId}/status`,
    { status, confirmed },
  );
  return res;
};

/**
 * Permanently delete a curriculum via DELETE /v2/curriculum/:curriculum_id.
 *
 * Call with no `confirmed` (or `confirmed: false`) to run the gate checks; call
 * with `confirmed: true` after the admin acknowledges the impact report to
 * perform the cascade delete. A DELETE body must be sent via the `data` config
 * key.
 */
const deleteCurriculum = async (
  curriculumId: string,
  confirmed?: boolean,
): Promise<AxiosResponse<ICurriculumDeleteSuccessResponse>> => {
  const res: AxiosResponse<ICurriculumDeleteSuccessResponse> = await api.delete(
    `/curriculum/${curriculumId}`,
    { data: { confirmed } },
  );
  return res;
};

export const curriculumService = {
  fetchCurriculums,
  fetchCurriculum,
  createCurriculum,
  updateCurriculum,
  updateOperationalTime,
  setCurriculumStatus,
  deleteCurriculum,
};
